module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d9MnS"))).then(() => module.bundle.root('dJXJK'));